import { Configurator, Environment } from 'types';

export module BaseUrls {
  const urls: any = process.env.URLS;

  const testTool: Configurator.State = Configurator.builder();

  export const getEnv = (useTestTool = false): string => {
    let env = process.env.NODE_ENV || Environment.Development;

    if (useTestTool && testTool) {
      env = testTool.hostModule.env;
    }

    return env;
  };

  const getHost = (type: string): string => {
    const byEnv = urls[getEnv(testTool != null)];

    if (`${process.env.USE_PROXY}` === 'true' || process.env.USE_HOST_PROXY) {
      return `${window.location.protocol}//${window.location.host}/${urls.proxy[type]}`;
    }

    if (`${process.env.USE_ENV_HOSTS}` === 'true') {
      return process.env[`${type.toUpperCase()}_API_URL`];
    }

    return byEnv[type];
  };

  export const isStage = getEnv(false) === Environment.Stage;
  export const isDev = getEnv(false) === Environment.Development;
  export const isProd = getEnv(false) === Environment.Production;
  export const testEnv =
    getEnv(false) === Environment.Development ||
    getEnv(false) === Environment.Stage;

  export const hotelsUrl = getHost('hotel');
  export const workflowUrl = getHost('workflow');
  export const suggestsUrl = getHost('suggests');
  export const mlApiUrl = getHost('ml');
}
